import { render } from "./supply-chain.vue?vue&type=template&id=6a56dd0e"
import script from "./supply-chain.vue?vue&type=script&lang=js"
export * from "./supply-chain.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__